import type { QuestionDefinition } from "@reno-estimator/core";
import { booleanQuestion, builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion } from "./interior-room-shared.js";

/**
 * Dining Room (Phase 13A) - see rules/dining-room.ts for the matching
 * calculator. No windows/doors question here (see the calculator's doc
 * comment for why).
 */
export const diningRoomQuestions: QuestionDefinition[] = [
  flooringQuestion("dining_room", 200, "dining room"),
  paintingQuestion("dining_room", 210),
  trimQuestion("dining_room", 220),
  lightingQuestion("dining_room", 230, "A statement chandelier or fixture is common scope for a dining room."),
  builtInsQuestion("dining_room", 240, "What about a built-in buffet or hutch?", "Custom buffet/hutch built-in"),
  booleanQuestion("dining_room_wall_treatment", "dining_room", "Adding an accent wall treatment (wainscoting, moulding, wallpaper)?", 260)
];
